// extracted by mini-css-extract-plugin
export var divider = "_1q-0";
export var dividerText = "_1q-2";
export var dividerVertical = "_1q-1";